// extracted by mini-css-extract-plugin
export default {"container":"BundledEditor-module_container__zGR29e"};